class Status {
    constructor(rawData) {
        this.options = [
            {
                label: 'Draft',
                value: 'draft',
            },
            {
                label: 'Published',
                value: 'published',
            },
        ];
    }

    toOptions() {
        return this.options;
    }

    toLabel(value) {
        return this.options.find((option) => option.value === value)?.label;
    }
}

export default Status;
